"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIconContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledIconContainer = styled_components_1.default.div `
  .Polaris-Icon {
    height: 1.1rem;
    width: 1.1rem;
  }
`;
